"use client";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { useEffect, useState, useMemo } from "react";
import { useTranslations } from "next-intl";

type ScreenLoaderProps = {
  fullScreen?: boolean;
  texts?: string[];
};

export default function ScreenLoader({ fullScreen = false, texts }: ScreenLoaderProps) {
  const t = useTranslations('screenLoader');
  
  // If custom texts are provided, use them; otherwise use translations
  const messages = useMemo(() => texts ?? [
    t('messages.0'),
    t('messages.1'),
    t('messages.2'),
    t('messages.3'),
    t('messages.4'),
    t('messages.5'),
    t('messages.6'),
    t('messages.7'),
    t('messages.8'),
    t('messages.9'),
    t('messages.10'),
    t('messages.11'),
    t('messages.12'),
    t('messages.13'),
    t('messages.14'),
  ], [texts, t]);
  
  const [currentMessage, setCurrentMessage] = useState(messages[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage(
        messages[Math.floor(Math.random() * messages.length)]
      );
    }, 2000); // Change message every 2 seconds

    return () => clearInterval(interval);
  }, [messages]);

  return (
    <div className={cn("fixed inset-0 bg-brand-500/70 flex flex-col items-center justify-center z-[9999]",
      fullScreen ? "bg-brand-500" : "bg-brand-500/50"
    )}>
      <Image
        src="/images/logo/logo_white.png"
        alt="waiting..."
        width={105}
        height={70}
        className="h-[40px] w-auto animate-bounce mb-4"
        priority
      />
      <p className="text-white font-semibold text-lg animate-pulse px-4 py-2 text-shadow-md">
        {currentMessage}
      </p>
    </div>
  );
}
